import React, { useEffect, useState } from 'react'
import './CreateModal.css';
import FilterFieldRenderer from '../FilterFieldRenderer/FilterFieldRenderer';
import { IoMdClose } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { getAllDepartments, getAllRoles } from '../../redux/UserReducer/action';

const CreateModal = ({ config, obj, setObj, onClose, handleSubmit }) => {

    const { rolesList, departments } = useSelector((store) => {
        return {
            rolesList: store.UserReducer.roles.rolesList,
            departments: store.UserReducer.departments
        }
    })

    const fields = config?.inputFields || [];
    const [errors, setErrors] = useState({});
    const [dynamicFields, setDynamicFields] = useState(fields);
    const [allRolesLimit, setAllRolesLimit] = useState(parseInt(sessionStorage.getItem('allRolesLimit')) || 2000);
    const dispatch = useDispatch();

    const [roleFilters, setRoleFilters] = useState({
        is_active: true
    });

    useEffect(() => {
        dispatch(getAllRoles(1, allRolesLimit, roleFilters));
    }, [dispatch, roleFilters, allRolesLimit]);

    useEffect(() => {
        dispatch(getAllDepartments);
    }, [dispatch]);

    useEffect(() => {
        // if (!rolesList?.length) return;

        // // extract unique parent roles
        // const uniqueParentRolesMap = new Map();

        // rolesList.forEach(role => {
        //     if (!uniqueParentRolesMap.has(role.role_id)) {
        //         uniqueParentRolesMap.set(role.role_id, {
        //             value: role.role_id,
        //             label: `${role.role_id} (${role.short_name})`
        //         });
        //     }
        // });

        // const parentRoleOptions = Array.from(uniqueParentRolesMap.values());

        if(!departments.length) return;

        // extract unique parent roles
        const uniqueDepartmentsMap = new Map();

        departments.forEach(department => {
            uniqueDepartmentsMap.set(department.department_id, {
                value: department.department_id,
                label: `${department.department_id} (${department.short_name})`
            });
        });

        const departmentOptions = Array.from(uniqueDepartmentsMap.values());

        // inject options into field config
        const updatedFields = fields.map(field => {
            // if (field.key === "parent_role_id") {
            //     return {
            //         ...field,
            //         options: parentRoleOptions
            //     };
            // }
            if (field.key === "department_id") {
                return {
                    ...field,
                    options: departmentOptions
                };
            }
            return field;
        });

        setDynamicFields(updatedFields);

    }, [fields, departments]);

    const handleChange = (key, value) => {
        let updatedObj = {
            ...obj,
            [key]: value
        };

        setObj(updatedObj);

        const field = fields.find(f => f.key === key);

        if (field?.validation) {
            const errorMsg = field.validation(value);

            setErrors(prev => ({
                ...prev,
                [key]: errorMsg
            }));
        }
    };

    const isSaveDisabled = () => {
        return (
            fields.some(
                (field) =>
                field.isMandatory &&
                (obj[field.key] === undefined ||
                obj[field.key] === null ||
                obj[field.key] === "")
            ) ||
            Object.values(errors).some(Boolean)
        );
    };

    // console.log({ fields });

    return (
        <div className="create-modal-overlay" onClick={onClose}>
            <div className="create-modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="create-modal-content">
                    <div className="create-modal-header">
                        <h5 className="create-modal-title">{config.title}</h5>
                        <button onClick={onClose} className="btn-close">
                            <IoMdClose size={24} />
                        </button>
                    </div>

                    <div className="create-modal-body">
                        <div className="row">
                            {/* {fields?.map(field => ( */}
                            {dynamicFields?.map(field => (
                                <div className="mb-3" key={field.key}>
                                    <label className="form-label">{field.label}</label>
                                    <FilterFieldRenderer
                                        field={field}
                                        value={obj[field.key]}
                                        onChange={handleChange}
                                        dynamicOptions

                                    />

                                    {errors[field.key] && (
                                        <div className="text-danger mt-1 text-start" style={{ fontSize: "12px" }}>
                                            {errors[field.key]}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="create-modal-footer">
                        <button 
                            // onClick={handleSubmit} 
                            onClick={() => {
                                // const payload = {
                                //     ...obj,
                                //     parent_role_id: obj.parent_role_id || null  //convert "" → null
                                // };

                                // handleSubmit(payload);
                                handleSubmit(obj);
                            }} 
                            className="create-btn btn-solid"
                            disabled={isSaveDisabled()}
                        >
                            Create
                        </button>
                        <button 
                            onClick={onClose} 
                            className="create-btn btn-outline"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateModal